import { create } from 'zustand'

export interface CoinData {
  symbol: string
  name: string
  logoUrl: string
  maxLeverage?: number
}

interface CommandState {
  isOpen: boolean
  setOpen: (open: boolean) => void
  toggleOpen: () => void
  selectedSymbol: string
  setSelectedSymbol: (symbol: string) => void
  currentPrice: number
  setCurrentPrice: (price: number) => void
  tradfiVenue: "hl" | "ostium" | null
  setTradfiVenue: (v: "hl" | "ostium" | null) => void
  availableCoins: CoinData[]
  setAvailableCoins: (coins: CoinData[]) => void
  isSignalLeaderboardOpen: boolean
  setSignalLeaderboardOpen: (open: boolean) => void
  toggleSignalLeaderboardOpen: () => void
}

export const useCommandStore = create<CommandState>((set) => ({
  isOpen: false,
  setOpen: (open) => set({ isOpen: open }),
  toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),
  selectedSymbol: "BTCUSDT",
  setSelectedSymbol: (symbol) => set({ selectedSymbol: symbol }),
  currentPrice: 0,
  setCurrentPrice: (price) => set({ currentPrice: price }),
  tradfiVenue: null,
  setTradfiVenue: (v) => set({ tradfiVenue: v }),
  availableCoins: [],
  setAvailableCoins: (coins) => set({ availableCoins: coins }),
  isSignalLeaderboardOpen: false,
  setSignalLeaderboardOpen: (open) => set({ isSignalLeaderboardOpen: open }),
  toggleSignalLeaderboardOpen: () => set((state) => ({ isSignalLeaderboardOpen: !state.isSignalLeaderboardOpen })),
}))
